export default "__VITE_ASSET__DiVngqTZ__"